<template>
  <div class="promotion">
    推广赚钱
  </div>
</template>

<script>
export default {};
</script>

<style></style>
